import { createElement } from "react";
import reactRender from "~/lib/reactRenderer";
import { type Root } from "react-dom/client";

import isEqual from "lodash/isEqual";

export default class TurboReactComponentElement extends HTMLElement {
  constructor() {
    super();
  }

  renderRoot: Root | undefined;

  get component() {
    return window.require(this.getAttribute("component") as string);
  }

  get props() {
    return JSON.parse(this.getAttribute("props") as string);
  }

  morph(
    event: Event & {
      detail: {
        newElement: Element | null;
      };
    },
  ) {
    if (!event.detail.newElement) {
      return;
    }

    // Prevent the default morphing behavior
    event.preventDefault();

    const newProps = JSON.parse(event.detail.newElement.getAttribute("props") as string);

    // Only re-render if the props have changed
    if (!isEqual(this.props, newProps)) {
      reactRender(createElement(this.component, newProps), this, this.renderRoot);
    }
  }

  connectedCallback() {
    this.renderRoot = reactRender(createElement(this.component, this.props), this);

    this.addEventListener<any>("turbo:before-morph-element", this.morph);
  }

  disconnectedCallback() {
    setTimeout(() => this.renderRoot?.unmount(), 0);

    this.removeEventListener<any>("turbo:before-morph-element", this.morph);
  }
}

declare global {
  interface Window {
    TurboReactComponentElement: typeof TurboReactComponentElement;
  }
}

if (!window.customElements.get("turbo-react-component")) {
  window.TurboReactComponentElement = TurboReactComponentElement;

  window.customElements.define("turbo-react-component", TurboReactComponentElement);
}
